import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { SearchBarPickerModeEnum } from './search-bar-picker.enum'
import { getSearchBarPickerClassNameByEnum } from './search-bar-picker.utils'

export interface ISearchBarPicker {
  label?: React.ReactNode
  placeholder: React.ReactNode
  value?: React.ReactNode
  className?: string
  isMobile?: boolean
  alternativeClassName?: string
  mode?: SearchBarPickerModeEnum
  onClick?: () => void
}

export const SearchBarPicker = ({
  onClick,
  label,
  placeholder = '',
  value,
  className,
  alternativeClassName = 'default',
  mode = SearchBarPickerModeEnum.DEFAULT,
}: ISearchBarPicker) => {
  return (
    <div
      className={clsx(
        s[getSearchBarPickerClassNameByEnum(mode)],
        className,
        s[alternativeClassName],
      )}
      onClick={onClick}
    >
      <div className={s.label}>{label}</div>
      <div className={value ? s.value : s.placeholder}>
        {value || placeholder}
      </div>
    </div>
  )
}
